import axios from "axios";

export const getData = (subUrl, onSuccess, onFail) => {
    let url = 'https://server.ntintegration.com' + subUrl;
    if (process.env.NODE_ENV !== 'production') {
        url = 'https://backend-dev-testing.ngrok.io' + subUrl;
    }

    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };

    axios.get(url, config)
        .then(response => {
            try {
                onSuccess(response);
            } catch(error) {
                console.log('GET error', error);
            }
        })
        .catch(err => {
            onFail(err)
        });
};

export const putData = (subUrl, data, onSuccess, onFail) => {
    let url = 'https://server.ntintegration.com' + subUrl;
    if (process.env.NODE_ENV !== 'production') {
        url = 'https://server.ntintegration.com' + subUrl;
    }

    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };

    axios.put(url, data, config)
        .then(response => {
            try {
                onSuccess(response)
            } catch(error) {
                console.log('PUT error', error);
            }
        })
        .catch(err => {
            onFail(err)
        });
};

export const postData = (subUrl, data, onSuccess, onFail) => {
    let url = 'https://server.ntintegration.com' + subUrl;
    if (process.env.NODE_ENV !== 'production') {
        url = 'https://backend-dev-testing.ngrok.io' + subUrl  ;
    }

    const config = {
        headers: {
            "Content-Type": "application/json"

        }
    };

    axios.post(url, data, config)
        .then(response => {
            try {
                onSuccess(response)
            } catch(error) {
                console.log('POST error', error)
            }
        })
        .catch(err => {
            onFail(err)
        });
};

export const postDataMetabase = (subUrl, data, onSuccess, onFail) => {
    let url = 'https://jbstatsbackend.com' + subUrl;
    if (process.env.NODE_ENV !== 'production') {
        url = 'http://jbstatsbackend.com' + subUrl;
    }

    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };

    axios.post(url, data, config)
        .then(response => {
            onSuccess(response)
        })
        .catch(err => {
            onFail(err)
        });
};
